document.addEventListener('DOMContentLoaded', function () {
  const buyButton = document.querySelector('#rze-buy-button');

  if (!buyButton) return;

  buyButton.addEventListener('click', function () {
    const variantId = buyButton.dataset.rzeVariant;

    if (!variantId) {
      alert('This product is currently unavailable.');
      return;
    }

    const productHandle = buyButton.dataset.productHandle || '';
    const variantTitle = buyButton.dataset.variantTitle || '';

    const rzeUrl =
      'https://rzewatches.com/cart/' +
      variantId +
      ':1' +
      '?utm_source=vostra' +
      '&utm_medium=referral' +
      '&utm_campaign=vostra_product' +
      '&attributes[source]=Vostra%20Designs' +
      '&attributes[vostra_product]=' + encodeURIComponent(productHandle) +
      '&attributes[vostra_variant]=' + encodeURIComponent(variantTitle);

    window.location.href = rzeUrl;
  });
});